import { ReactComponent as CloseIcon } from "console/assets/icons/closeIcon.svg";
import DayPickerInput from "../common/DayPickerInput";
import SelectBox from "../common/selectBox";
import Input from "../common/input";
import Button from "common/components/button";
import { useState } from "react";
import { useGetCommonPayMethod } from "common/hooks/common/useGetCommonPayMethod";
import { usePostPaymentSales } from "common/hooks/console/sales/usePostSales";

type PaymentPopProps = {
    customerIdx: number;
    orderIdx: number;
    onClose: () => void;
    handleSubmitCallback: () => void;
    handleErrorCallback: (message: string) => void;
};
export default function PaymentPop({ customerIdx, orderIdx, onClose, handleSubmitCallback, handleErrorCallback }: PaymentPopProps) {
    const [payDateError, setPayDateError] = useState<boolean>(false);
    const [payDate, setPayDate] = useState<Date | undefined>(new Date());
    const [methodError, setMethodError] = useState<boolean>(false);
    const [payAmountError, setPayAmountError] = useState<boolean>(false);
    const [methodValue, setMethodValue] = useState<string>("");
    const [method, setMethod] = useState<string>("");
    const [payAmount, setPayAmount] = useState<string>("");
    const [memoInput, setMemoInput] = useState<string>("");

    const { data: methodData } = useGetCommonPayMethod({ payment_category: 1 });
    const { mutate: postSalesMutate } = usePostPaymentSales(customerIdx, orderIdx, undefined);

    const handleSubmit = () => {
        let hasError = false;
        if (!payDate) {
            setPayDateError(true);
            hasError = true;
        }
        if (!method.trim()) {
            setMethodError(true);
            hasError = true;
        }
        if (!payAmount.trim()) {
            setPayAmountError(true);
            hasError = true;
        }
        if (hasError) return;

        const getFormattedDate = (date: Date | undefined) => {
            if (!date) return "";
            return date.toLocaleDateString("sv-SE");
        };

        postSalesMutate(
            {
                payment_date: getFormattedDate(payDate),
                payment_method: method,
                payment_amount: Number(payAmount.replace(/,/g, "")),
                payment_memo: memoInput,
            },
            {
                onSuccess: data => {
                    setPayDate(new Date());
                    setMethod("");
                    setMethodValue("");
                    setPayAmount("");
                    setMemoInput("");
                    onClose();

                    handleSubmitCallback();
                    // addToast({
                    //     type: "success",
                    //     message: "입금 내역을 등록하었습니다.",
                    // });
                },
                onError: (error: any) => {
                    const errorMessage = error?.response?.data?.message || "알 수 없는 오류가 발생했습니다.";
                    handleErrorCallback(errorMessage);
                    // showPop({
                    //     title: errorMessage,
                    //     rightButton: undefined,
                    //     type: "negative",
                    //     onRightClick: () => {},
                    // });
                },
            },
        );
    };

    const handleChange = (e: any) => {
        let rawValue = e.target.value.replace(/[^0-9]/g, "");

        if (rawValue === "") {
            setPayAmount("");
            return;
        }

        const numericValue = Number(rawValue);
        setPayAmount(numericValue.toLocaleString());
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]"
            // onClick={() => setPaymentPop(false)}
            onClick={onClose}
        >
            <div className="bg-white rounded-lg shadow-lg w-[480px] flex justify-center flex-col" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center px-6 py-5">
                    <p className="text-2xl font-bold">입금 등록</p>
                    <CloseIcon
                        className="cursor-pointer"
                        onClick={() => {
                            setMemoInput("");
                            setMethodValue("");
                            setPayDate(new Date());
                            setPayAmount("");
                            onClose();
                        }}
                    />
                </div>
                <div className="bg-gray6 px-5 py-3 flex flex-col gap-2">
                    <div className="flex gap-1">
                        <div
                            className={`${payDateError && "border-error border"} bg-white py-1.5 px-3 rounded-lg w-full flex items-center justify-between`}
                        >
                            <p className="text-sm">입금일자</p>
                            <DayPickerInput
                                right
                                initialDate={payDate}
                                onDateChange={date => {
                                    setPayDateError(false);
                                    setPayDate(date);
                                }}
                                className="h-full rounded-lg max-w-[110px]"
                            />
                        </div>
                        <div
                            className={`bg-white py-1.5 px-3 rounded-lg w-full border ${methodError ? "border-error" : "border-gray4"} flex items-center gap-2`}
                        >
                            <p className="text-sm flex-shrink-0">결제수단</p>
                            <SelectBox
                                status="view"
                                className="w-full"
                                options={
                                    methodData?.data.map(method => ({
                                        value: method.payment_order.toString(),
                                        label: method.payment_name,
                                    })) || []
                                }
                                value={methodValue}
                                onChange={value => {
                                    const selectedMethod = methodData?.data.find(method => method.payment_order.toString() === value);
                                    setMethodValue(value);
                                    setMethod(selectedMethod?.payment_name || "");
                                    setMethodError(false);
                                }}
                            />
                        </div>
                    </div>
                    <div
                        className={`bg-white items-center text-sm pl-3 ${payAmountError ? "border-error" : "border-gray4"} rounded-lg flex justify-between border`}
                    >
                        <p>입금액</p>
                        <Input
                            inputClassName="border-none pb-[4.5px]"
                            value={payAmount}
                            onChange={handleChange}
                            price
                            className={`font-bold px-3 `}
                        />
                    </div>
                    <Input value={memoInput} onChange={e => setMemoInput(e.target.value)} placeholder="메모입력(100자)" maxLength={100} />
                </div>
                <div className="flex px-6 py-4 w-full gap-2">
                    <Button
                        size="L"
                        className="w-full"
                        onClick={() => {
                            setMemoInput("");
                            setMethodValue("");
                            setPayDate(new Date());
                            setPayAmount("");
                            onClose();
                        }}
                    >
                        취소
                    </Button>
                    <Button onClick={handleSubmit} size="L" status="regist" className="w-full">
                        입금등록
                    </Button>
                </div>
            </div>
        </div>
    );
}
